// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-wrapper[data-v-60f35ab6] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n}\n.app-wrapper[data-v-60f35ab6]:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.app-wrapper.mobile.openSidebar[data-v-60f35ab6] {\n    position: fixed;\n    top: 0;\n}\n.drawer-bg[data-v-60f35ab6] {\n  background: #000;\n  opacity: 0.3;\n  width: 100%;\n  top: 0;\n  height: 100%;\n  position: absolute;\n  z-index: 999;\n}\n", ""]);
// Exports
module.exports = exports;
